import { AnyAction } from "redux";
import * as constants from "../constants/error.constants";

export const hideErrorNotification = (): AnyAction => ({
  type: constants.ON_NOTIFICATION_HIDE,
});
